import axiosHelper from "../../../../axiosHelper";
import { APIUSEROLD, API_FAILURE } from "../../../../config/constants";
import { apiErrors } from "../../../../helper";
import Toaster from "../../../common/Toaster";

export function getAuditScoreMasterList() {
    const request = axiosHelper.get(`${APIUSEROLD.getAuditScoreMaster}`);
    return request
      .then((response) => {
        if (response?.data?.result) {
          // You can perform additional actions if needed
          return response?.data; // Return the response to the caller
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
      } else{
  
        throw error; // Re-throw the error to the caller
      }
      });
  }
  export function getApproverListService() {
    const request = axiosHelper.get(`${APIUSEROLD.getApproveMasterList}`);
    return request
      .then((response) => {
        if (response?.data) {
          // You can perform additional actions if needed
          return response?.data; // Return the response to the caller
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
      } else{
  
        throw error; // Re-throw the error to the caller
      }
      });
  }
  export function getProfileCodeService() {
    const request = axiosHelper.get(`${APIUSEROLD.getProfileCodeService}`);
    return request
      .then((response) => {
        if (response?.data) {
          // You can perform additional actions if needed
          return response?.data; // Return the response to the caller
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
      } else{
  
        throw error; // Re-throw the error to the caller
      }
      });
  }
  export function AddAuditScoreApproverMaster(data,callback){
    return (dispatch) => {
      //dispatch({ type: API_REQUEST });
      const request = axiosHelper.post(APIUSEROLD.AddAuditMasterScore, data)
      request
          .then((response) => {
              if (response.data) {
                  callback(response?.data)
              }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              apiErrors(error)
          } else{
            Toaster.error(error?.response?.data?.ErrorMessage)
            dispatch({ type: API_FAILURE })
            // apiErrors(error)
             callback(error);
          }
           
          })
  }
  }
  export function AddAuditDocumentApproverMaster(data,callback){
    return (dispatch) => {
      //dispatch({ type: API_REQUEST });
      const request = axiosHelper.post(APIUSEROLD.AddAuditMasterDocument, data)
      request
          .then((response) => {
              if (response.data) {
                  callback(response?.data)
              }
          })
          .catch((error) => {
            
            dispatch({ type: API_FAILURE })
            if (error.response.status === 401) {
              apiErrors(error)
          }else{

            Toaster.error(error?.response?.data?.ErrorMessage)
          }
              // apiErrors(error)
              //  callback(error);
          })
  }
  }

  export function deleteDocumentApproverMaster(id, callback) {
    axiosHelper.delete(`${APIUSEROLD.deleteDocumentApprover}?documentApproverMasterid=${id}`)
      .then((response) => {
        if (callback) {
          callback(null, response); // Call the callback with null for the error parameter and the response
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
      }else{

        if (callback) {
          callback(error, null); // Call the callback with the error and null for the response
        }
      }
      });
  }